export default "__VITE_ASSET__CVOv7zvB__"